import uuid from 'uuid';

function generateRequestId() {
  const reqId = uuid.v4();
  return reqId;
}

export { generateRequestId };
